module.exports = require("fs-extra-promise");


//////////////////
// WEBPACK FOOTER
// external "fs-extra-promise"
// module id = 120
// module chunks = 0 1